// extracted by mini-css-extract-plugin
export default {"show":"header_show__sUQIA","hide":"header_hide__ugEWP"};